import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { SketchPicker } from 'react-color';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { useStyles } from './styles';

interface ColorPickerProps {
  id?: string;
  name?: string;
  color: string;
  colorSetter: (changeColor: string) => void,
}
export const ColorPicker: React.FC<ColorPickerProps> = ({
  id, name, color, colorSetter,
}) => {
  const styles = useStyles();
  const [openFontColorPicker, setOpenFontColorPicker] = useState(false);
  const [fontColorHex, setFontColorHex] = useState<string>(color);

  const onChangeFrontColor = (value: {hex: string}) => {
    setFontColorHex(value.hex);
    colorSetter(value.hex);
  };

  return (
    <Box position="relative">
      <Box
        width="30px"
        height="30px"
        borderRadius="4px"
        position="absolute"
        style={{
          backgroundColor: fontColorHex,
          cursor: 'pointer',
          top: '50%',
          left: '10px',
          transform: 'translateY(-50%)',
        }}
      />
      { openFontColorPicker ? (
        <Box className={styles.popover}>
          <Box className={styles.cover} onClick={() => setOpenFontColorPicker(false)} />
          <SketchPicker color={fontColorHex} onChange={onChangeFrontColor} />
        </Box>
      ) : null }
      <TextField
        id={id}
        variant="outlined"
        name={name}
        value={fontColorHex}
        onClick={() => setOpenFontColorPicker(!openFontColorPicker)}
        InputProps={{
          readOnly: true,
          className: styles.colorPicker,
          startAdornment: (
            <InputAdornment position="start">
              <Box
                width="30px"
                height="30px"
              />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};
